import { ReactElement, ReactNode } from "react";
import { Navigation } from "../Navigation";

interface Props {
  navigation: ReactElement<typeof Navigation>;
  children: ReactNode;
}

export const PageLayout = ({ navigation, children }: Props) => {
  return (
    <>
      <div
        className={`flex w-[calc(100vw)] max-w-full h-full flex-col gap-4 p-4 mx-auto`}
      >
        {navigation}
        <div className="flex-1 min-h-0">{children}</div>
      </div>
    </>
  );
};
